import { type FC } from 'react';

import { Facebook, Twitter } from '@backyard-ui/icons';

type SocialMedia = {
  label: string;
  name: 'twitter' | 'facebook';
  icon: FC;
  url: string;
};

const socialMediaList: SocialMedia[] = [
  {
    label: 'Twitter',
    name: 'twitter',
    icon: Twitter,
    url: 'https://twitter.com/home?status=',
  },
  {
    label: 'Facebook',
    name: 'facebook',
    icon: Facebook,
    url: 'https://www.facebook.com/sharer/sharer.php?u=',
  },
];

export default socialMediaList;
